import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  text-align: justify;

  ul {
    gap: 0.5rem;
    display: grid;
  }
`;
